import * as React from 'react'
import { connect } from 'react-redux'
import type { ButtonProps } from 'types/content-editor'
import type { Playlist } from 'types/playlist'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import ColorInput from 'components/ui/color-input'
import Input from 'components/ui/input'
import Label from 'components/ui/label'
import PlaylistSelect from 'pages/campaigns/campaign-details/playlist-select'
type Props = {
  value: ButtonProps
  className?: string
  colors?: readonly string[]
  onChange: (e: React.SyntheticEvent<any>) => any
  onColorChange: (prop: string, color: string) => any
  onPlaylistSelect: (playlistId: number) => any
  playlist: Playlist | null | undefined
  boundsRef?: {
    current: null | HTMLDivElement
  }
  validationErrors:
    | {
        link?: string
      }
    | null
    | undefined
}

const mapStateToProps = (state, { value: { playlist_id } }) => {
  return {
    playlist: getPlaylist(state, {
      id: playlist_id,
    }),
  }
}

const ButtonPropsView = ({
  className,
  colors,
  value,
  playlist,
  boundsRef,
  onChange,
  onColorChange,
  onPlaylistSelect,
  validationErrors,
}: Props) => {
  const {
    link,
    caption,
    style: { backgroundColor, color },
  } = value
  return (
    <div className={className}>
      <div className="rich-text-toolbar__settings__list__row">
        <Label
          validationError={validationErrors && validationErrors.link}
          caption="Link"
        />
        <Input
          value={link}
          name="link"
          onChange={onChange}
          className="Campaigns_LargeInput"
        />
      </div>
      <div className="rich-text-toolbar__settings__list__row">
        <Label caption="Select playlist" />
        <PlaylistSelect
          value={
            playlist && playlist.playlist_id
              ? {
                  value: playlist.playlist_id,
                  label: playlist.name,
                }
              : null
          }
          onChange={values => {
            const playlist_id = (Array.isArray(values) ? values[0] : values)
              .value
            onPlaylistSelect(playlist_id)
          }}
        />
      </div>
      <div className="rich-text-toolbar__settings__list__row">
        <Label caption="Button text" />
        <Input
          value={caption}
          name="caption"
          onChange={onChange}
          className="Campaigns_LargeInput"
        />
      </div>
      <div className="rich-text-toolbar__settings__list__row">
        <Label caption="Button text color" />
        <ColorInput
          colors={colors}
          name="style.color"
          value={color}
          portal
          boundsRef={boundsRef}
          onChange={color => onColorChange('style.color', color.hex)}
        />
      </div>
      <div className="rich-text-toolbar__settings__list__row">
        <Label caption="Button color" />
        <ColorInput
          colors={colors}
          name="style.backgroundColor"
          value={backgroundColor}
          portal
          boundsRef={boundsRef}
          onChange={color => onColorChange('style.backgroundColor', color.hex)}
        />
      </div>
    </div>
  )
}

export default connect(mapStateToProps, {})(ButtonPropsView) as any
